export default __webpack_public_path__ + "static/media/mon_24.9dbd80c0.png";